(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['CompanySession', '$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler(CompanySession, $rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
                          Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromStateParams) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;
                $rootScope.fromStateParams = fromStateParams;
                $rootScope.showHeaderNavbar = true;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }


                //checkHeaderToShow
                if ($rootScope.toState) {
                    if ($rootScope.toState.views && $rootScope.toState.name.includes('supplierPanel-v2')) {

                        var content = $rootScope.toState.views['content@'];
                        if (content)
                            $rootScope.$broadcast('hideNavBar');

                        var subContent = $rootScope.toState.views['subcontent'];
                        if (subContent)
                            $rootScope.$broadcast('showNavBar');

                    }
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });


            });

            function hasValidSubscription() {


            }

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);

                //check company subscription
                checkValidSubscription();


            });

            function checkValidSubscription() {
                CompanySession.checkValidSubscription(function (valid) {

                    if ($rootScope.toState.views && !valid) {
                        if ($rootScope.toState.name.includes('supplierPanel-v2.reserveList')
                            || $rootScope.toState.name.includes('supplierPanel-v2.newReserve')
                            || $rootScope.toState.name.includes('supplierPanel-v2.companyCustomer')
                            || $rootScope.toState.name.includes('supplierPanel-v2.companyServants')
                            || $rootScope.toState.name.includes('supplierPanel-v2.reserveServices')
                            || $rootScope.toState.name.includes('supplierPanel-v2.eventItemList')
                            || $rootScope.toState.name.includes('supplierPanel-v2.reportExport')
                            || $rootScope.toState.name.includes('supplierPanel-v2.setting')
                            || $rootScope.toState.name.includes('supplierPanel-v2.calendar-v2')
                            || $rootScope.toState.name.includes('supplierPanel-v2.dashboard')
                            || $rootScope.toState.name.includes('supplierPanel-v2.invoiceInfoList')
                            || $rootScope.toState.name.includes('supplierPanel-v2.companyPaymentLog')
                        ) {
                            //its not valid
                            $state.go('supplierPanel-v2.companySubscriptionStatusV2');
                        }
                    }

                })

            }

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();
